import { DataField } from "@iventis/domain-model/model/dataField";
import { ScheduleConfigVersionType } from "@iventis/domain-model/model/scheduleConfigVersionType";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import React, { FunctionComponent, useMemo } from "react";
import { EditScheduleConfigContainer } from "./edit-event-block-types";
import { EditScheduleVersionType } from "./edit-schedule-version-type";
import { getScheduleVersionTitle, orderScheduleVersions } from "./edit-schedule-version-type.helpers";

interface EditScheduleVersionTypesProps {
    scheduleVersionTypes: ScheduleConfigVersionType[];
    dataFields: DataField[];
    onValueChange: (scheduleVersionTypeChanges: ScheduleConfigVersionType[]) => void;
}

export const EditScheduleVersionTypes: FunctionComponent<EditScheduleVersionTypesProps> = ({ scheduleVersionTypes, dataFields, onValueChange }) => {
    const translate = useIventisTranslate();

    const onScheduleVersionChange = (updatedScheduleVersionType: ScheduleConfigVersionType) => {
        onValueChange([...scheduleVersionTypes.filter(({ id }) => id !== updatedScheduleVersionType.id), updatedScheduleVersionType]);
    };

    const orderedScheduleVersion = useMemo(() => orderScheduleVersions(scheduleVersionTypes), [scheduleVersionTypes]);

    return (
        <EditScheduleConfigContainer>
            {orderedScheduleVersion.map((scheduleVersionType, index) => (
                <EditScheduleVersionType
                    key={scheduleVersionType.id}
                    title={getScheduleVersionTitle(index, translate)}
                    scheduleVersionType={scheduleVersionType}
                    dataFields={dataFields}
                    onValueChange={onScheduleVersionChange}
                    allowNameEdit={index === 1}
                />
            ))}
        </EditScheduleConfigContainer>
    );
};
